export const mileageDisplay = (d) => {
  if(d.mileage){
    return d.mileage.toFixed(2)+'公里'
  }else{
    return '暂无'
  }
}

export const km = (d) => {
  if(d){
    return d.toFixed(2)+'公里'
  }
}